import config from "../../config"
import RequestService from "../RequestService"

const sendEmail = (id, email, successCallback, failureCallback) => {
  RequestService.post(`${config.backendUrl}/tickets/${id}/send_email`, { email: email }, successCallback, failureCallback)
}

export default sendEmail;